export default __webpack_public_path__ + "static/media/green.a566fb99.svg";